import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Kishor Patel',
      business: 'C Store Owner',
      location: 'North Carolina',
      quote: "With Autometa's innovative technology, we streamlined our processes and created a more engaging atmosphere for customers.",
      logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=375,fit=crop/mxB4Gjwo2Xh7OnGZ/rdugalarialogo-AGB21eqWP1F0Z3Wg.webp',
    },
    {
      name: 'Jane Smith',
      business: 'Pizza Hut Manager',
      location: 'North Carolina',
      quote: "The AI voice agent significantly boosted our sales and allowed us to focus on our core work instead of being burdened by phone calls.",
      logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,h=375,fit=crop/mxB4Gjwo2Xh7OnGZ/pizzahutlogo-AR0LQveDDqI99qPn.jpg',
    },
    {
      name: 'Restaurant Owner',
      business: 'Local Restaurant',
      location: 'United States',
      quote: "AutoMeta completely transformed our call handling. Our team can focus on service instead of phones. Customers love the fast responses.",
      logo: 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=375,fit=crop/mxB4Gjwo2Xh7OnGZ/whichwichlogo-mjE7OpzXKrukJxQJ.png',
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2 className="testimonials-title">
          Why Businesses Love AutoMeta
        </h2>
        <p className="testimonials-subtitle">See how businesses save time and boost revenue with AutoMeta.</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="testimonial-logo">
                <img 
                  src={testimonial.logo} 
                  alt={testimonial.business} 
                  loading="lazy"
                  width="60"
                  height="60"
                />
              </div>
              
              <blockquote className="testimonial-quote">
                "{testimonial.quote}"
              </blockquote>
              
              <div className="testimonial-author">
                <div className="author-name">{testimonial.name}</div>
                <div className="author-business">{testimonial.business}</div>
                <div className="author-location">{testimonial.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
